import CultureFlag from "components/Culture/CultureFlag";
import React, { useContext, useEffect } from "react";
import { Button } from "semantic-ui-react";
import { FilterContext } from "../FilterContext";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { getCulture, getLabel, getSortedLCIDs, initialCultureFilter } from "./FilterTypes/CultureFilterType";

const Item = ({ culture }: { culture: server.dto.Culture }) => {
  return <div className="flex">
    <CultureFlag lcid={culture.value} />
    <span className="margin-left-small">{culture.text}</span>
  </div>;
};

const CultureFilter = () => {
  const title = RESX.Language.resxLanguage;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("culture", {
    getTitle: () => title,
    renderSelection: (filter) => <div className="flex">
      {getSortedLCIDs(filter).map((lvl, index) =>
        <React.Fragment key={lvl}>
          <Item culture={getCulture(lvl)} />
          {index !== filter.selectedLCIDs.length - 1 && <span className="padding-right">,</span>}
        </React.Fragment>
      )}
    </div>,
    hasValue: (filter) => filter.selectedLCIDs.length > 0,
    reset: () => initialCultureFilter,
    areEqual: (a, b) => areArrayValuesEqual(a.selectedLCIDs, b.selectedLCIDs)
  });
  useEffect(() => {
    setInitialValue("culture", initialCultureFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedLCIDs, setSelectedLCIDs] = React.useState(initialCultureFilter.selectedLCIDs);

  const onPopupClose = () => {
    onApply();
  };

  const onPopupOpen = () => {
    setSelectedLCIDs(getValue("culture").selectedLCIDs);
    setPopupOpen(true);
  };

  const onLCIDToggle = (lcid: server.dto.LCID) => {
    const isSelected = selectedLCIDs.some(l => l === lcid);
    const newSelection = isSelected
      ? selectedLCIDs.filter(l => l !== lcid)
      : [...selectedLCIDs, lcid];
    setSelectedLCIDs(newSelection);
  };

  const onApply = (e?) => {
    e?.preventDefault();
    setValue("culture", { selectedLCIDs });
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<form onSubmit={onApply}>
        <div className="margin-bottom">
          <SelectableList
            noSearch
            items={serverReference.cultures.map(l => l.value)}
            renderItem={l => <Item culture={getCulture(l)} />}
            selectedItems={selectedLCIDs}
            onItemToggled={onLCIDToggle}
            getId={opt => opt}
            getName={opt => getLabel(opt)}
          />
        </div>

        <Button fluid type="submit" primary >
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default CultureFilter;